export const automatorKey = 'automator';

export enum Operation {
  find = 'find',
  empty = 'empty',
  create = 'create',
}
